import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  Col, Row,
  Avatar,
  Typography,
  Layout,
  Card
} from "antd";
import { ImageUrl } from "../../helpers/Functions";
import { UPLOADS_URL } from "../../config/constants/api";
import { FaLongArrowAltLeft } from "react-icons/fa";
import moment from "moment";

const StudentDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const student = location.state?.student;
  useEffect(() => {
    if (!student) {
      navigate(-1);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Row
        className="whiteBackground"
        style={{
          backgroundColor: "white",
          height: "100vh",
          justifyContent: "center",
        }}
      >
        <Col xs={24} md={16}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",

              padding: "50px 20px",
            }}
          >
            <Row style={{ marginBottom: 20 }}>
              <Col>
                <FaLongArrowAltLeft
                  style={{
                    fontSize: "30px",
                    color: "#333d47",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate(-1)}
                />
              </Col>
            </Row>
            <Card
              className="infoBox"
              bordered={false}
              style={{
                width: "100%",
                padding: "15px",
              }}
            >
              <Avatar
                size={180}
                src={
                  !student?.image
                    ? ImageUrl("avatar.png")
                    : UPLOADS_URL + "/" + student?.image
                }
              />
              <Row style={{ marginTop: 20 }}>
                <Col xs={12} sm={7}>
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginTop: 0,
                    }}
                  >
                    ID
                  </Typography.Title>
                  <Typography.Text
                    className="fontFamily1"
                    style={{
                      fontSize: "14px",
                      color: "grey",
                      textAlign: "left",
                    }}
                  >
                    {student?._id}
                  </Typography.Text>
                </Col>

                <Col xs={12} sm={7}>
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginTop: 0,
                    }}
                  >
                    First Name
                  </Typography.Title>
                  <Typography.Text
                    className="fontFamily1"
                    style={{
                      fontSize: "14px",
                      color: "grey",
                      textAlign: "left",
                    }}
                  >
                    {student?.firstName}
                  </Typography.Text>
                </Col>

                <Col xs={12} sm={7}>
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginTop: 0,
                    }}
                  >
                    Last Name
                  </Typography.Title>
                  <Typography.Text
                    className="fontFamily1"
                    style={{
                      fontSize: "14px",
                      color: "grey",
                      textAlign: "left",
                    }}
                  >
                    {student?.lastName}
                  </Typography.Text>
                </Col>
              </Row>
              <Row style={{ marginTop: 40 }}>
                <Col xs={12} sm={7}>
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginTop: 0,
                    }}
                  >
                    Email
                  </Typography.Title>
                  <Typography.Text
                    className="fontFamily1"
                    style={{
                      fontSize: "14px",
                      color: "grey",
                      textAlign: "left",
                    }}
                  >
                    {student?.email}
                  </Typography.Text>
                </Col>
                <Col xs={12} sm={7}>
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginTop: 0,
                    }}
                  >
                    Phone Number
                  </Typography.Title>
                  <Typography.Text
                    className="fontFamily1"
                    style={{
                      fontSize: "14px",
                      color: "grey",
                      textAlign: "left",
                    }}
                  >
                    {student?.phoneNumber}
                  </Typography.Text>
                </Col>

                <Col xs={12} sm={7}>
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginTop: 0,
                    }}
                  >
                    Joining Date
                  </Typography.Title>
                  <Typography.Text
                    className="fontFamily1"
                    style={{
                      fontSize: "14px",
                      color: "grey",
                      textAlign: "left",
                    }}
                  >
                    {student?.createdAt
                      ? moment(student?.createdAt).format("DD/MM/YYYY")
                      : "N/A"}
                  </Typography.Text>
                </Col>
              </Row>
              <Row style={{ marginTop: 40 }}>
                <Col xs={12} sm={7}>
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginTop: 0,
                    }}
                  >
                    City
                  </Typography.Title>
                  <Typography.Text
                    className="fontFamily1"
                    style={{
                      fontSize: "14px",
                      color: "grey",
                      textAlign: "left",
                    }}
                  >
                    {student?.city}
                  </Typography.Text>
                </Col>

                <Col xs={12} sm={7}>
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginTop: 0,
                    }}
                  >
                    State
                  </Typography.Title>
                  <Typography.Text
                    className="fontFamily1"
                    style={{
                      fontSize: "14px",
                      color: "grey",
                      textAlign: "left",
                    }}
                  >
                    {student?.state}
                  </Typography.Text>
                </Col>

                <Col xs={12} sm={7}>
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginTop: 0,
                    }}
                  >
                    Zip Code
                  </Typography.Title>
                  <Typography.Text
                    className="fontFamily1"
                    style={{
                      fontSize: "14px",
                      color: "grey",
                      textAlign: "left",
                    }}
                  >
                    {student?.zip}
                  </Typography.Text>
                </Col>
              </Row>
            </Card>
          </div>
        </Col>
      </Row>
    </Layout>
  );
};

export default StudentDetails;
